import { RowTitle } from './RowTitle.component';
import { ForecastParamCode } from 'pleinchamp-api-client';
import { useMemo } from 'react';
import {
  TemperatureChartLoader,
  TemperatureChartProps,
} from '@meteo/components/TemperatureChart/TemperatureChart.component';
import dynamic from 'next/dynamic';
import { MetricsType, MetricsType24H } from '../../utils';

interface Props {
  onMouseEnter: (index: number) => void;
  is15Days?: boolean;
  is36h?: boolean;
  hoveredIndex?: number;
  metrics: Array<MetricsType | MetricsType24H>;
}

const TemperatureChart = dynamic<TemperatureChartProps>(
  () => import('../../../TemperatureChart/TemperatureChart.component').then(module => module.TemperatureChart),
  { loading: () => <TemperatureChartLoader uniqueKey="tempChart" />, ssr: false }
);

const EMPTY: Array<string | number> = [];

function WeatherChart({ onMouseEnter, is15Days, is36h, metrics, hoveredIndex }: Props) {
  const temperatureMetrics = useMemo(() => metrics.find(m => m.key === ForecastParamCode.AirTemperatureInCelsius), [
    metrics,
  ]);
  const temperatures = temperatureMetrics ? temperatureMetrics.data : EMPTY;

  return (
    <tr className="chart-row-temperature">
      <th>
        <RowTitle forecastParam={ForecastParamCode.AirTemperatureInCelsius} is15Days={is15Days} is36h={is36h} />
      </th>
      <td className="table-navigation left" rowSpan={1} />
      {temperatures.map((_, i) => (
        <td
          key={i.toString()}
          className={hoveredIndex === i ? 'emphasis' : ''}
          onMouseEnter={() => onMouseEnter(i)}
          rowSpan={1}
        >
          {i === 0 && <TemperatureChart cellWidth={is36h ? 70 : 60} temperatures={temperatures as number[]} />}
        </td>
      ))}
      <td className="table-navigation right" rowSpan={1} />
    </tr>
  );
}

export { WeatherChart };
